import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactenosService } from './contactenos.service';
import { Router } from '@angular/router';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { DepartamentoEntry } from 'src/app/shared/entrys/departamento.entry';
import { MunicipioEntry } from 'src/app/shared/entrys/municipio.entry';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { AlertType } from 'src/app/shared/models/alert.model';
// tslint:disable-next-line:max-line-length
import { ModalTerminoCondicionesComponent } from 'src/app/components/seguridad/layouts/modal-termino-condiciones/modal-termino-condiciones.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminosCondicionesService } from 'src/app/shared/services/terminos-condiciones.service';
import { ModalTermino1581Component } from '../../layouts/modal-termino-1581/modal-termino-1581.component';
@Component({
	selector: 'app-contactenos',
	templateUrl: './contactenos.component.html',
	styleUrls: ['./contactenos.component.scss']
})
export class ContactenosComponent implements OnInit {
	departamentos: Array<DepartamentoEntry>;
	municipios: Array<MunicipioEntry>;
	formContactenos: FormGroup;
	terminos: string;

	constructor(private basicasLoVService: BasicasLoVService,
		private contactoService: ContactenosService, private router: Router, private modalService: NgbModal,
		private formBuilder: FormBuilder, private alertsService: AlertsService,
		private terminosCondicionesService: TerminosCondicionesService) { }

	ngOnInit() {
		this.formContactenos = this.formBuilder.group({
			nombres: ['', Validators.required],
			municipio_id: ['', Validators.required],
			departamento_id: ['', Validators.required],
			correo_electronico: ['', [Validators.required, ConfirmeValidators.emailValidator]],
			nit: ['', [Validators.required, ConfirmeValidators.numberValidator]],
			numero_telefonico: ['', [Validators.required, ConfirmeValidators.numberValidator]],
			nombre_establecimiento: [''],
			numero_rnt: ['', ConfirmeValidators.numberValidator],
			mensaje_enviado: ['', Validators.required],
			captcha: ['', Validators.required],
			acepta_termino: ['']
		});
		this.basicasLoVService.getDepartamentos(null).subscribe(resultado => {
			if (resultado.result) {
				this.departamentos = resultado.data as Array<DepartamentoEntry>;
			}
		});
		this.contactoService.getParametro({
			parametro_id: 'TEXTO_CONTACTENOS_1581',
			agrupacion: 'TEXTO',
			auxiliar: '1'
		}).subscribe(resultado => {
			if (resultado.result) {
				this.terminos = resultado.data;
			}
		});
	}

	enviarFormulario() {
		this.contactoService.create({ ...this.formContactenos.value }).subscribe(resultado => {
			if (resultado.result) {
				this.formContactenos.reset();
				this.alertsService.alert(AlertType.Success,
					'El mensaje fue enviado exitosamente.', '/contactenos', resultado.control.code.toString(), true);
				this.router.navigate(['/home']);
			}
		});
	}

	onMunicipio() {
		this.basicasLoVService.getMunicipiosxDepartamento(this.formContactenos.value.departamento_id).subscribe(resultado => {
			if (resultado.result) {
				this.municipios = resultado.data as Array<MunicipioEntry>;
			}
		});
	}

	openModalTermino() {
		this.terminosCondicionesService.getTextoPlano(null).subscribe(resultTC => {
			if (resultTC.result) {
				const modalRef = this.modalService.open(ModalTermino1581Component,
					{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
				modalRef.componentInstance.terminos = resultTC.data[0];
				modalRef.result.then((resultModalTC) => {

				});
			}
		});
	}
}
